import { Button } from "@blueprintjs/core";
import React from "react";
import styled from "styled-components";

import { useCommonHooks } from "../../hooks";

import { ICustomButtonProps } from "./ICustomButtonProps";

const IconContainer = styled.span`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface IUserButtonProps extends ICustomButtonProps {}

export const UserButton: React.FunctionComponent<IUserButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent,
  text,
  hideText = true,
  small,
}) => {
  const { fullUserName, t } = useCommonHooks();

  const initials = React.useMemo(
    () =>
      fullUserName
        .split(" ")
        .map((w) => w[0])
        .join("")
        .toUpperCase(),
    [fullUserName]
  );
  return (
    <Button
      icon={<IconContainer>{initials}</IconContainer>}
      minimal={minimal}
      onClick={onClick}
      text={!hideText ? text || t("User") : null}
      intent={intent}
      loading={loading}
      disabled={disabled}
      small={small}
    />
  );
};
